var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3066(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.963,
    height: 35.967,
    viewBox: "0 0 35.963 35.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69701",
    "data-name": "Path 69701",
    d: "M730.03,510.625c-.1-.03-.208-.059-.33-.086a.432.432,0,0,0-.523.419v7.678c0,.16-.177.282-.4.282s-.4-.125-.4-.28v-7.9a.43.43,0,0,0-.392-.429h-.01a.429.429,0,0,0-.465.427v7.909c0,.16-.178.281-.4.281s-.4-.125-.4-.28v-7.9a.429.429,0,0,0-.48-.426h-.01a.43.43,0,0,0-.374.426v7.885c0,.16-.178.282-.4.282s-.4-.125-.4-.28v-7.534a.429.429,0,0,0-.565-.408,2.653,2.653,0,0,0-.376.16.421.421,0,0,0-.213.371v5.4c0,2.993,1.037,5.5,2.436,6.192l-.3,11.543a14.916,14.916,0,0,1-5.57.19l.078,3.1a17.758,17.758,0,0,0,6.491-.378h0c.406-.1.808-.21,1.2-.336l-.357-14.112c1.4-.689,2.436-3.2,2.436-6.192v-5.6A.427.427,0,0,0,730.03,510.625Z",
    transform: "translate(-704.791 -501.827)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69702",
    "data-name": "Path 69702",
    d: "M640.379,457.282a17.98,17.98,0,0,0-5.345,35.146v.01a18.393,18.393,0,0,0,2,.493l-.234-9.164c1.4-.688,2.438-3.2,2.438-6.192,0-3.519-1.44-6.383-3.212-6.383s-3.212,2.857-3.212,6.383c0,2.993,1.037,5.5,2.436,6.192l-.138,5.455a14.919,14.919,0,1,1,11.726-.509l.085,3.3a17.982,17.982,0,0,0-6.547-34.73Zm-5.564,16.413.026,7.827C633.025,478.815,634.815,473.694,634.815,473.694Z",
    transform: "translate(-622.402 -457.28)",
    fill: "#cf2969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3066);
export default __webpack_public_path__ + "static/media/Group 3066.28e245daed1210747609871868218ae3.svg";
export { ForwardRef as ReactComponent };